import { Row, Col, Button } from 'react-bootstrap';
import './Despesas.css';

export default function Receitas() {
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Receitas</small></p>
        </Col>
        <Col xs="12">
            <h1>Receitas</h1>
            <p>Para consultar as receitas da Alepe, você deverá acessar o Portal da Transparência do Governo do Estado de Pernambuco, disponível no link abaixo. Ao ser direcionado para esta página, será preciso preencher as informações, conforme o guia abaixo.</p>
        </Col>
        <Col xs="12" className='text-center sessao-despesas'>
            <a href="https://transparencia.pe.gov.br/receitas/receitas-totais/" rel="noopener" target="_blank"><Button className='button'>CLIQUE AQUI PARA ACESSAR O PORTAL DA TRANSPARÊNCIA DO GOVERNO DE PE</Button></a>
        </Col>
        <Col xs="12" className="sessao-despesas">
            <h3>Visualizando as receitas da ALEPE no Portal do Governo do Estado</h3>
            <p>1. Ao clicar no botão acima, você será direcionado para a página das receitas no Portal da Transparência do Governo de Pernambuco;</p>
            <p>2. Selecione o Ano que deseja consultar;</p>
            <p>3. Na caixa de seleção Unidade Gestora, escolha a opção ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO, conforme a imagem abaixo.</p>
            <p>4. Se desejar, você poderá preencher as outras opções da tela ou clique em Pesquisar para exibir todos os resultados da pesquisa.</p>
        </Col>
        <Col xs="12" className="sessao-despesas text-center mb-4">
            <img src='/img/receitas-pe.png'/>
        </Col>
    </Row>
}